import { Path } from '@/main/router/routerPath';

import { EventConfiguration } from './eventconfiguration';
import { EventFrequency } from './eventfrequency';
import { CommunicationEventConfiguration } from './CommunicationEventConfiguration';

export const router = new Path('DialogueMarketing').addChildren([
	EventConfiguration.router,
	EventFrequency.router,
	CommunicationEventConfiguration.router,
]);
